import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/nationwide/login.vue'),
    meta: {
      title: "巨能重卡充电大数据",
      basicScreenWidth: 1920,
      basicScreenHeight: 1080,
      bgColor: 'black'
    },
  },
  {
    path: '/bigData',
    name: 'bigData',
    component: () => import('../views/nationwide/index.vue'),
    meta: {
      title: "巨能重卡充电大数据",
      basicScreenWidth: 1920,
      basicScreenHeight: 1080,
      bgColor: 'black'
    },
  },
  {
    path: '/mapDraw',
    name: 'mapDraw',
    component: () => import('../views/nationwide/mapDraw.vue'),
    meta: {
      title: "全国地图圈地工具",
      basicScreenWidth: 1920,
      basicScreenHeight: 1080,
      bgColor: 'black'
    },
  },
  /*以下为移动端使用的页面*/
    {
      path: '/mobileLogin',
      name: 'mobileLogin',
      component: () => import('../views/mobile/login.vue'),
      meta: {
        title: "巨能重卡充电大数据",
        basicScreenWidth: 1920,
        basicScreenHeight: 1080,
        bgColor: 'black'
      },
    },
    {
      path: '/mobileBigData',
      name: 'mobileBigData',
      component: () => import('../views/mobile/index.vue'),
      meta: {
        title: "巨能重卡充电大数据",
        basicScreenWidth: 1920,
        basicScreenHeight: 1080,
        bgColor: 'black'
      },
    }
]
const router = new VueRouter({
  routes
})

export default router